
;(function($, window, document) {
  
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const preset = window.localStorage.getItem('reduce-motion');
  
  const autoplay = ((preset !== 'true') && !reduceMotion.matches)

  const tickers = $('.block-ticker');

  if (tickers.length > 0) {

    $.each(tickers, function() {

      const ticker = $(this).find('.ticker')[0];
      const ticker_track = $(this).find('.ticker-track')[0];
      const ticker_controls = $(this).find('.ticker-playpause')[0];
      
      if (!autoplay) {
        ticker.classList.remove('playing');
      }

      ticker_controls.addEventListener('click', () => {

        // console.log('pause/play ticker')

        if (ticker.classList.contains('playing')) {
          ticker.classList.remove('playing');
        } else {
          ticker.classList.add('playing');
        }

      });


      document.addEventListener('tms:pause-videos', () => {
        ticker.classList.remove('playing');
      });

    });

  }


  

// @ts-ignore
})(jQuery, window, document);